import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import LoadingPopup from "../helpers/loading_component.js";
import { secretKey } from "../.././data";
import emailjs from "@emailjs/browser";

const MySwal = withReactContent(Swal2);

const EditLeadSupport = (props) => {
  const [value, setValue] = useState(props.leadData.support);
  const [loading, setLoading] = useState(false);
  const [banks, setBanks] = useState([]);
  const [supports, setSupports] = useState([]);
  const [subject, setSubject] = useState("");
  const [typeSubject, setTypeSubject] = useState("1");

  const fetchBanks = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getUsers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setBanks(data);
        fetchSupports();
      })
      .catch((error) => {});
  };

  const fetchSupports = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getSupport", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSupports(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchBanks();
  };

  useEffect(() => {
    getData();
  }, []);

  const editLead = async (e) => {
    if (validatePayment()) {
      setLoading(true);

      var body = {
        leadId: props.leadData.id,
        status: props.leadData.status,
        leadName: props.leadData.name,
        field: "support",
        subject: subject,
        value: value === "x" ? "" : value,
      };

      await fetch("https://apidevkppp.ftpeople.pl/updateLead", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {
          emailjs.init("user_7x2uGk2osoyVegzDMAi4G");
          var templateParams = {
            to: banks.filter((el) => el.name === value)[0].mail,
            reply_to: props.uData.mail,
            content: `Dzień dobry, proszę o: ${subject}. ID kontaktu w systemie: ${props.leadData.id}.`,
            subject:
              props.leadData.name + " " + props.leadData.id + " - " + subject,
            user_name: props.uData.name,
            user_phone: props.uData.phone,
          };

          emailjs.send("KPPP", "template_h43760d", templateParams).then(
            function (response) {},
            function (error) {}
          );
        })
        .catch((error) => {});

      props.logClientAction(
        "Edytowano wsparcie leada: " + props.user,
        props.leadData.id
      );

      MySwal.fire({
        icon: "success",
        title: "Edytowano",
        text: "lead",
      }).then(async (result) => {
        props.close();
      });
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const validatePayment = (e) => {
    if (value.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className="mainContainerAddClientContact">
      {loading ? (
        <LoadingPopup id={"popUpLoading"} />
      ) : (
        <>
          <div className="closeButtonAP">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div className="inputBox">
            <div className="inputCol_1">
              <label>
                Wsparcie <span className="requiredStar">*</span>
              </label>
              <select
                style={{ boxSizing: "border-box" }}
                type="text"
                id="name"
                name="name"
                value={value}
                onChange={(e) => {
                  setValue(e.target.value);
                }}
              >
                {!value ? (
                  <>
                    <option key={0} value={0}>
                      Wybierz...
                    </option>
                  </>
                ) : (
                  ""
                )}
                <option key={999} value={"x"}>
                  {"brak danych"}
                </option>
                {banks.map((el) => (
                  <>
                    <option key={el.id} value={el.name}>
                      {el.name}
                    </option>
                  </>
                ))}
              </select>
            </div>
          </div>
          <div className="inputBox">
            <div className="inputCol_1">
              {typeSubject === "1" ? (
                <>
                  <button
                    className="paymentMenuButton"
                    onClick={() => {
                      setTypeSubject("2");
                    }}
                  >
                    uzupełnij temat ręcznie
                  </button>
                </>
              ) : (
                <>
                  <button
                    className="paymentMenuButton"
                    onClick={() => {
                      setTypeSubject("1");
                    }}
                  >
                    wybierz temat z listy
                  </button>
                </>
              )}
            </div>
          </div>
          {typeSubject === "1" ? (
            <>
              <div className="inputBox">
                <div className="inputCol_1">
                  <label>
                    Wiadomość - temat <span className="requiredStar">*</span>
                  </label>
                  <select
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={subject}
                    onChange={(e) => {
                      setSubject(e.target.value);
                    }}
                  >
                    {!subject ? (
                      <>
                        <option key={0} value={0}>
                          Wybierz...
                        </option>
                      </>
                    ) : (
                      ""
                    )}
                    {supports
                      ? supports.map((e) => (
                          <option key={e.id} value={e.name}>
                            {" "}
                            {e.name}
                          </option>
                        ))
                      : ""}
                  </select>
                </div>
              </div>
            </>
          ) : (
            ""
          )}
          {typeSubject === "2" ? (
            <>
              <div className="inputBox">
                <div className="inputCol_1">
                  <label>
                    Wiadomość - temat <span className="requiredStar">*</span>
                  </label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={subject}
                    onChange={(e) => {
                      setSubject(e.target.value);
                    }}
                  />
                </div>
              </div>
            </>
          ) : (
            ""
          )}

          <div className="saveBoxAP">
            <button className="paymentMenuButton" onClick={editLead}>
              zapisz
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default EditLeadSupport;
